export const enDoubleGisTranslations = {
    DOUBLE_GIS_REPORT__DISABLE_TOOLTIP: 'To see the analytics, choose filters so that only one company is left',
    DOUBLE_GIS__LOGIN_FAILED: 'Error: login failed',
};
